/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The counters above the workshops list.
 * @export
 * @interface WorkshopListSummary
 */
export interface WorkshopListSummary {
    /**
     * Workshops overlapping today (Europe/Zagreb)
     * @type {number}
     * @memberof WorkshopListSummary
     */
    today: number;
    /**
     * Workshops overlapping the days from today to the coming Sunday, inclusive
     * @type {number}
     * @memberof WorkshopListSummary
     */
    this_week: number;
}

/**
 * Check if a given object implements the WorkshopListSummary interface.
 */
export function instanceOfWorkshopListSummary(value: object): value is WorkshopListSummary {
    if (!('today' in value) || value['today'] === undefined) return false;
    if (!('this_week' in value) || value['this_week'] === undefined) return false;
    return true;
}

export function WorkshopListSummaryFromJSON(json: any): WorkshopListSummary {
    return WorkshopListSummaryFromJSONTyped(json, false);
}

export function WorkshopListSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopListSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'today': json['today'],
        'this_week': json['this_week'],
    };
}

export function WorkshopListSummaryToJSON(json: any): WorkshopListSummary {
    return WorkshopListSummaryToJSONTyped(json, false);
}

export function WorkshopListSummaryToJSONTyped(value?: WorkshopListSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'today': value['today'],
        'this_week': value['this_week'],
    };
}

